import { Team__Nogaleras } from "../teams/Nogaleras";
import { Team__Potras } from "../teams/Potras";
import { Team__Pythons } from "../teams/Pythons";
import { Team__Raptors } from "../teams/Raptors";
import { Team__UTPaquime } from "../teams/UTPaquime";

const Nogaleras = {
  team: Team__Nogaleras,
  playingPlayers: [],

  goals: 17,
  penaltyGoals: 0,
  isWinner: false,
};

const Raptors = {
  team: Team__Raptors,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UTPaquime,
  playingPlayers: [],

  goals: 33,
  penaltyGoals: 0,
  isWinner: false,
};

const Potras = {
  team: Team__Potras,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Pythons = {
  team: Team__Pythons,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

// =========================
// =========================
// =========================

const Finalist = {
  team: {
    name: "Finalist",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada6 = {
  jornadaPosition: 6,
  matches: [
    {
      team1: Nogaleras,
      team2: UTPaquime,

      isCompleted: true,
      isPlaying: false,
      day: "Sabado",
      date: "2025-08-02",
      time: "12:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
